import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import CrovianHome from "./crovian/CrovianHome";
import CrovianContact from "./crovian/CrovianContact";
import CrovianBrief from "./crovian/CrovianBrief";
import SiteHeader from "./crovian/SiteHeader";
import SiteFooter from "./crovian/SiteFooter";
import "./App.css";

function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const timer = window.setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 80);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}

function LegacyRedirect({ section = "business" }) {
  return <Navigate to={`/#${section}`} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <SiteHeader />
      <Routes>
        <Route path="/" element={<CrovianHome />} />
        <Route path="/contact" element={<CrovianContact />} />
        <Route path="/project-brief" element={<CrovianBrief />} />
        <Route path="/about" element={<LegacyRedirect section="company" />} />
        <Route path="/services" element={<LegacyRedirect section="business" />} />
        <Route path="/web-development" element={<LegacyRedirect section="business" />} />
        <Route path="/mobile-app-development" element={<LegacyRedirect section="business" />} />
        <Route path="/artificial-intelligence" element={<LegacyRedirect section="ai" />} />
        <Route path="/amc-plan" element={<LegacyRedirect section="capabilities" />} />
        <Route path="/get-quote" element={<Navigate to="/project-brief" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <SiteFooter />
    </BrowserRouter>
  );
}
